module.exports = __webpack_public_path__ + "static/media/downGreyArr.d33c369f.svg";